import { render, staticRenderFns } from "./UpcomingAwardsTable.vue?vue&type=template&id=473cdc99&scoped=true&"
import script from "./UpcomingAwardsTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./UpcomingAwardsTable.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./UpcomingAwardsTable.vue?vue&type=style&index=0&id=473cdc99&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473cdc99",
  null
  
)

export default component.exports